export default "__VITE_ASSET__734e3f58__"